export default __webpack_public_path__ + "static/media/coreograph-logo.800e3973.svg";